import {handleCustomerReferenceError} from "./lib/customer-reference-error";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query';
import App from './App';
import './styles/global.css';

// SW 更新完了時に自動リロード（バックグラウンド復帰でも最新版を反映）
navigator.serviceWorker?.addEventListener('controllerchange', () => {
  window.location.reload();
});

const queryClient: QueryClient = new QueryClient({
  mutationCache: new MutationCache({onError: error => handleCustomerReferenceError(error, queryClient)}),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5分間キャッシュ
      gcTime: 30 * 60 * 1000, // 30分間メモリ保持
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
